import { Button } from "components/DesignSystem/Button/Button";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { BackendError } from "types/utils/error";
import { useMarkTaxFilingPaidMutation } from "v2/store/taxSetupApi";

type GoToDashboardButtonProps = {
  groupId: string;
};

export const GoToDashboardButton = ({ groupId }: GoToDashboardButtonProps) => {
  const { dispatch: setGroup } = useCurrentGroupContext();
  const { alertToast } = useToast();
  const [markTaxFilingPaid, { isLoading }] = useMarkTaxFilingPaidMutation();

  const handleGoToDashboard = async (): Promise<void> => {
    try {
      await markTaxFilingPaid({ groupId }).unwrap();
      setGroup({
        type: "SET_GROUP",
        payload: { has_paid_for_tax_filing: true },
      });
    } catch (error) {
      alertToast({
        message:
          (error as BackendError).data?.error?.message ??
          "Something went wrong",
      });
    }
  };

  return (
    <Button
      customType="primary"
      size="small"
      block
      onClick={handleGoToDashboard}
      disabled={isLoading}
      isLoading={isLoading}
    >
      Go to dashboard
    </Button>
  );
};
